<div class="error-page-container">
  <mat-card class="error-page-card">
    <div class="error-page-header">
      <mat-card-title class="error-page-title">
        404
      </mat-card-title>
      <mat-card-subtitle class="error-page-subtitle">
        Page Not Found
      </mat-card-subtitle>
    </div>

    <mat-card-content>
      The page you were looking for was not found.
    </mat-card-content>
    <mat-card-actions>
      <button type="button"
              mat-button
              (click)="goBack()"
              color="primary">Go back</button>
    </mat-card-actions>
  </mat-card>
</div>